import type { DogConfig } from "../../config/types";
import { distance, isApproaching, moveToward, runFrame, type Agent, type RiderView } from "./types";

export type DogState = "sit" | "alert" | "chase" | "flee";

export interface Dog extends Agent {
    state: DogState;
    timer: number;
    age: number;
}

export function createDog(x: number, y: number): Dog {
    return { x, y, pose: "sit", flipX: false, state: "sit", timer: 0, age: 0 };
}

export function hitDog(dog: Dog, cfg: DogConfig): Dog {
    return { ...dog, state: "flee", timer: cfg.tumbleS, pose: "tumble" };
}

export function stepDog(dog: Dog, rider: RiderView, dt: number, cfg: DogConfig): Dog {
    const d = { ...dog, age: dog.age + dt, timer: Math.max(0, dog.timer - dt) };

    switch (d.state) {
        case "sit":
            if (isApproaching(d, rider) && distance(d, rider) < cfg.triggerM) {
                return { ...d, state: "alert", timer: cfg.alertS, flipX: rider.x > d.x };
            }
            return d;

        case "alert":
            return d.timer > 0 ? d : { ...d, state: "chase", timer: cfg.chaseS };

        case "chase": {
            if (d.timer === 0) return { ...d, state: "flee" };
            const tx = rider.x + rider.vx * cfg.leadS;
            const ty = rider.y + rider.vy * cfg.leadS;
            return { ...moveToward(d, tx, ty, cfg.speed, dt), pose: runFrame(d.age, 8, "run_a", "run_b") };
        }

        case "flee": {
            if (d.timer > 0) return { ...d, pose: "tumble" };
            const away = d.x >= rider.x ? 1 : -1;
            return { ...moveToward(d, d.x + away * 10, d.y, cfg.fleeSpeed, dt), pose: runFrame(d.age, 8, "run_a", "run_b") };
        }
    }
}
